<template>
  <nav class="flex flex-column mobile:flex-row bg-card pd-medium radius-small">
    <RouterLink
      :to="basePath + '/profile'"
      class="flex flex-v-center pd-small mn-b-thin radius-small hover:bg-base"
      :class="{ 'bg-base': isActive('profile') }"
    >
      <!-- Иконки — из спрайта проекта (те же, что в сайдбаре дашборда). -->
      <Icon name="profile" :size="24" class="mn-r-thin flex-child-none" />
      <span class="ws-nowrap">{{ t('auth.nav.profile') }}</span>
    </RouterLink>

    <RouterLink
      :to="basePath + '/account'"
      class="flex flex-v-center pd-small radius-small hover:bg-base"
      :class="{ 'bg-base': isActive('account'), 'mn-b-thin': isOwnProfile }"
    >
      <Icon name="lock" class="mn-r-thin i-medium flex-child-none"/>
      <span class="ws-nowrap">{{ t('auth.nav.account') }}</span>
    </RouterLink>

    <RouterLink
      v-if="isOwnProfile"
      :to="basePath + '/notifications'"
      class="flex flex-v-center pd-small radius-small hover:bg-base"
      :class="{ 'bg-base': isActive('notifications') }"
    >
      <Icon name="notifications" :size="24" class="mn-r-thin flex-child-none" />
      <span class="ws-nowrap">{{ t('auth.nav.notifications') }}</span>
    </RouterLink>
  </nav>
</template>

<script setup>
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useI18n } from 'vue-i18n'
  import Icon from '@martyrs/src/design-system/components/Icon/Icon.vue';
  const route = useRoute()
  const { t } = useI18n()

  // Корень маунта настроек: и /profile/edit/*, и settings-маунт
  // (см. getProfileSettingsRoutes) заканчиваются одним из табов.
  const basePath = computed(() => route.path.replace(/\/(profile|account|notifications)$/, ''))

  function isActive (tab) {
    return route.path.endsWith('/' + tab)
  }

  // Backoffice: admin правит ЧУЖОГО юзера. «Уведомления» — настройки текущей
  // сессии, в backoffice их не показываем.
  const isOwnProfile = computed(() => !route.matched.some(r => r.meta?.context === 'backoffice'))
</script>
